module.exports = __webpack_public_path__ + "media/images/img/intaview_company/isid_tag-4aea115e34ef01e926802ec514ffc5f2.png";